import React from 'react'
import styled from 'styled-components'
import ColorConfig from '../../config/ColorConfig'

interface Props {
	label: string
	url: string
	isActive: boolean
}

const TopnavLink: React.FC<Props> = props => {
	return (
		<Link href={props.url} isActive={props.isActive}>
			<Text isActive={props.isActive}>{props.label}</Text>
		</Link>
	)
}

interface LinkProps {
	isActive: boolean
}

const Link = styled.a.attrs(props => ({
	href: props.href,
	className: 'clickable',
}))<LinkProps>`
	padding-left: 7px;
	padding-right: 7px;

	color: ${props => (props.isActive ? ColorConfig.Primary : '')};
`

const Text = styled.div<LinkProps>`
	color: ${props => (props.isActive ? ColorConfig.Primary : 'var(--text-color)')};
	font-weight: 600;

    &:hover {
        color: ${ColorConfig.Primary} !important;
    }
`

export default TopnavLink
